import { ref, watch } from 'vue'
import { defineStore } from 'pinia'
import { useEcho } from '@/composables/echo'
import { useApi } from '@/composables/api'

export const useEchoStore = defineStore('echo', () => {
	const { echoClient } = useEcho()

	const newOrders = ref(0)
	const newMessages = ref(0)
	const newChatMessages = ref(0)
	const newTicketMessages = ref(0)
	const event = ref(null)
	const action = ref(null)
	const newOrderData = ref(null)
	const data = ref(null)


	if (echoClient) {
		echoClient.private('admin').listen('.OrderUpdate', (e) => {
			newOrders.value = e.count.new
			event.value = 'OrderUpdate'
			action.value = e.action

			if (e.action == 'created') {
				document.getElementById('sound-file').play()
			}
			console.log('Order')
		})

		echoClient.private('admin').listen('.SendChat', (e) => {
			event.value = 'SendChat'
			data.value = e // Сохраняем данные сообщения
			document.getElementById('sound-fileChat').play()
		})

		echoClient.private('admin').listen('.SendMessageTicket', (e) => {
			event.value = 'SendMessageTicket'
			data.value = e // Сохраняем данные сообщения
			document.getElementById('sound-fileMesaage').play()
		})

		echoClient.private('admin').listen('.MessageUpdate', (e) => {
			if (e.count?.tickets !== undefined) {
				newTicketMessages.value = e.count.tickets;
			}
			if (e.count?.chats !== undefined) {
				newChatMessages.value = e.count.chats;
			}
		})
		useApi(true, 'index', 'orders', { where_model: { value: 'count_new' } }).then(
			(response) => {
				if (response.ok.value) {
					newOrders.value = response.result.value.meta.total
				}
			}
		)

		useApi(true, 'index', 'chats', { where_model: { value: 'count_new' } }).then(
			(response) => {
				if (response.ok.value) {
					newChatMessages.value = response.result.value.meta.total
				}
			}
		)

		useApi(true, 'index', 'message-tickets', { where_model: { value: 'count_new' } }).then(
			(response) => {
				if (response.ok.value) {
					newTicketMessages.value = response.result.value.meta.total
				}
			}
		)
	}

	return { newOrders, newOrderData, newChatMessages,newTicketMessages, event, action, data }
})
